import { Route, Routes } from 'react-router-dom';
import Home from './Home';
import RedeemPage from './RedeemPage';

const RedeemRoutes = () => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="redeem/:id" element={<RedeemPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default RedeemRoutes;
